// axios
import axios from 'axios';
import secret from '@/assets/utils/secret';
import router from '@/router';

const baseURL = process.env.VUE_APP_API;
const deviceKey = 'web-user';

const instance = axios.create({
  baseURL,
  headers: {
  	secret,
    device: deviceKey
  }
});

// Add interceptors
instance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status == 401) {

    sessionStorage.clear()
    localStorage.clear()

    if(router.currentRoute.meta.permission !== '*') {
      window.location = '/login'  
    }
  }

  return Promise.reject(error)
})

export default instance